export default "__VITE_ASSET__C3yDASNK__"